// extracted by mini-css-extract-plugin
export default {"spinner":"DvsL17wgJKBv2nzgFv0n"};